// @ts-nocheck
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { selectAllProducts } from "../stores/menu/productsSlice";
import { useLanguageContext } from "../context/languageContext";
import businessConfig from "../config/business";
import { formatUnit } from "../utils/price";
import MenuImage from "./MenuImage";

/**
 * The dishes the kitchen puts its name to.
 *
 * Read from the menu data rather than listed here: the printed menu marks its own
 * with "Specialiteti i lokalit", so marking another dish that way is all it takes
 * for it to appear. Nothing to keep in sync.
 */
export const Specialities = () => {
    const categories = useSelector(selectAllProducts);
    const { t, language } = useLanguageContext();
    const navigate = useNavigate();

    const specials = (categories || [])
        .flatMap((category) => category.menuItems || [])
        .filter((item) => /specialitet/i.test(item.description || ""));

    if (specials.length === 0) return null;

    const nameOf = (product) => {
        if (!product?.itemTranslation) return product.name;
        const map = {
            en: 'englishName', it: 'italianName', sq: 'albanianName', de: 'germanName',
            es: 'spanishName', pl: 'polishName', ukr: 'ukrainianName',
        };
        return product.itemTranslation[map[language]] || product.name;
    };

    return (
        <section className="px-4 pt-2 pb-6">
            <div className="relative overflow-hidden rounded-[1.25rem] bg-[#0B1E3B] shadow-[0_10px_30px_-16px_rgba(11,30,59,0.9)]">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-16 -left-12 w-48 h-48 rounded-full bg-[#1B3B6F] opacity-50 blur-[70px]"></div>
                </div>

                <div className="relative z-10 px-5 pt-5 pb-2">
                    <p className="text-[8px] font-black uppercase tracking-[0.22em] text-[#E9C46A]">
                        {t("houseSpecialitiesNote", "What this kitchen is known for")}
                    </p>
                    <h2 className="mt-1 text-lg font-clash text-white tracking-tight">
                        {t("houseSpecialities", "House Specialities")}
                    </h2>
                    <div className="mt-2 h-px w-10 bg-[#E9C46A]/60"></div>
                </div>

                <div className="relative z-10 px-3 pb-4 pt-1">
                    {specials.map((product) => (
                        <button
                            key={product.id}
                            onClick={() => navigate(`/menu?categoryId=${product.menuCategoryId}&itemId=${product.id}`)}
                            className="w-full flex items-center gap-3.5 px-2 py-3 rounded-xl text-left active:bg-white/[0.06] transition-colors"
                        >
                            <div className="w-[52px] h-[52px] flex-shrink-0 rounded-xl overflow-hidden bg-white/10 ring-1 ring-white/15">
                                <MenuImage
                                    src={product.imageUrl}
                                    alt={nameOf(product)}
                                    icon={product.icon}
                                    className="w-full h-full object-cover"
                                />
                            </div>

                            <div className="min-w-0 flex-1">
                                <h3 className="text-[13px] font-bold text-white leading-snug line-clamp-2">
                                    {nameOf(product)}
                                </h3>
                                <p className="mt-0.5 text-[11px] font-bold text-[#E9C46A]">
                                    {product.price} {businessConfig.currency}
                                    {product.priceUnit && (
                                        <span className="ml-1.5 text-[9px] font-black uppercase tracking-wider text-white/35">
                                            {formatUnit(t, product.priceUnit)}
                                        </span>
                                    )}
                                </p>
                            </div>

                            <FaChevronRight className="flex-shrink-0 text-white/25" size={11} />
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Specialities;
